import { ReducerBuilder } from './reducerBuilder';
import { SharingDataListState } from 'acscp/store';
import { SharingDataRequest } from 'acscp/api/requests';
import { SharingDataList } from 'acscp/api/models/sharingDataList';

export const sharingDataReducer =
    new ReducerBuilder<SharingDataListState>({})
    .successfulRequestCase(SharingDataRequest, (state, sharingDataList: SharingDataList, request) => ({
            ...state,
            [request.bookingId] : sharingDataList.shared
        }))
    .build();
